<template>
    <div class="payApvlProRoleTable">
        <!-- header slot 保存 取消 -->
        <header style="margin-bottom: 20px;">
           <slot name="saveButton" :row="multipleSelection"></slot>
           <slot name="cancelButton"></slot>
        </header>

        <el-table ref="multipleTable" size="small" style="width: 100%; min-height: 400px;" border :data="tableData" @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" :label="$t('payApvlSet.roleName'/**角色名称*/)">
                <el-table-column align="center" prop="roleName" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" :placeholder="$t('payApvlSet.inputFilter'/**关键字筛选*/)" v-model="vmRoleName" @change="handleChangeInputSelect" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" :label="$t('payApvlSet.roleType'/**角色类型*/)">
                <el-table-column align="center" prop="roleTypeTxt" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-select :placeholder="$t('payApvlSet.select'/**请选择*/)" v-model="vmRoleType" @change="handleChangeInputSelect" clearable>
                            <el-option
                                v-for="item in roleTypeOptions"
                                :key="item.codeitemid"
                                :label="item.codeitemname"
                                :value="item.codeitemid"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>

        <!-- footer pagination -->
        <footer style="margin-top:5px;">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
        </footer>
    </div>
</template>

<script>
/**
 * API
 * - getPayApvlPageRoleInfo  table列表
 * - postPayApvlCodeList     下拉列表
 */
import { getPayApvlPageRoleInfo, postPayApvlCodeList } from '@/api/wage/paymentApproval'

export default {
    name: 'payApvlProRoleTable',

    data() {
        return {
            tableData: [],
            multipleSelection: [],

            vmRoleName: '',         // v-m 角色名称
            vmRoleType: '',         // v-m 角色类型
            roleTypeOptions: [],    // 角色类型列表

            currentPage: 1,         // 当前页
            pageSize: 5,            // 条/页
            total: 0,               // 总条目数
        }
    },

    mounted() {
        this.getPayApvlPageRoleInfo()
        this.postPayApvlCodeList('9083')
    },

    methods: {
        /**
         * @description API table data
         */        
        getPayApvlPageRoleInfo() {
            let params = {
                size: this.pageSize,            // 显示条数
                current: this.currentPage,      // 当前页
                name: this.vmRoleName,          // 角色名称
                roleType: this.vmRoleType       // 角色类型
            }
            getPayApvlPageRoleInfo(params).then(res => {
                let data = res.data.data
                if (!data.records || data.records.lenght === 0) return
                this.tableData = data.records
                this.total = data.total
            })
        },

        /**
         * @description API 下拉列表
         */
        postPayApvlCodeList(codeSetId) {
            let params = {
                codeSetId,          // 9083
            }
            postPayApvlCodeList(params).then(res => {
                let data = res.data.data
                if (!data || data.lenght === 0) return
                this.roleTypeOptions = Object.freeze(data)
            })
        },

        /**
         * @description 表头输入下拉搜索
         * @description 角色名称
         * @description 角色类型
         */
        handleChangeInputSelect(v) {
            this.currentPage = 1
            this.getPayApvlPageRoleInfo()
        },

        /**
         * @description 行 选择
         */
        handleSelectionChange(row) {
            if(row.length!==0){
                console.log(row)
                row.forEach(r => {
                    if (Object.keys(r).length > 0) {
                        this.multipleSelection = [r]
                    }
                })
            } else {
                this.multipleSelection = []
            }
            this.tableData.forEach((item)=>{
                if(row.length!==0){
                    if(item.id!==row[[row.length-1]].id){
                        this.$refs.multipleTable.toggleRowSelection(item, false)
                    }
                }		
            })
            
        },


        /** footer pagination */
        /**
         * @description 页面切换
         */
        handleCurrentChange(v) {
            this.currentPage = v
            this.getPayApvlPageRoleInfo()
        },
        

        /** ref 父组件使用的方法 */
        /**
         * ! 父组件通过ref 清楚子组件的方法
         * @description 取消时 清楚table选择
         */        
        clear() {
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection()
        },

        /**
         * @description 父组件 点击选择角色时 选中表格的选项
         */
        open(id) {
            let row = {}
            let data = this.tableData
            data.forEach(item => {
                if (item.id == id) {
                    row = item
                }
            })
            this.$refs.multipleTable.toggleRowSelection(row)
        }


    },

}
</script>

<style lang="scss">
.payApvlProRoleTable .el-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    padding: 10px 5px;
    .el-pager li { border: none !important; }
    .el-pagination__editor.el-input .el-input__inner { height: 24px; }
}
.payApvlProRoleTable .el-table  {
    th > .cell { height: auto; }
    thead .own-cancal--lh div { line-height: 0; padding: 0; }
    .own-cancal--lh .el-select div { padding: 0; }
    .own-cancal--lh { padding: 10px; }
}
</style>
